import React from "react";

export default class CustomInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        if(this.props.onChange) {
            this.props.onChange(event, this.props.validator);
        }
    }

    render() {
        return (
            <div>
                <input 
                    id={this.props.id} 
                    name={this.props.name} 
                    placeholder={this.props.placeholder} 
                    value={this.props.value} 
                    onChange={this.handleChange} 
                    type={this.props.type} 
                    pattern={this.props.pattern} 
                    maxLength={this.props.maxLength} 
                    required={this.props.required} 
                    disabled={this.props.disable} 
                    autoComplete="off" 
                    className={(this.props.isValid ? 'valid' : 'invalid')}
                />
                {this.props.isValid === false && this.props.value !== '' && <div className="input-error">{this.props.ruleMessage}</div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/components/CustomInput.js